var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"height":"95vh"},attrs:{"src":_vm.privacyUrl,"width":"100%","frameborder":"0","allowfullscreen":""}},[_c('p',[_vm._v("Your browser does not support iframes.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }